import React, { useState } from "react";
import {
  Divider,
  IconButton,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  ListItemAvatar,
  ListItem,
  List,
  TextField,
} from "@material-ui/core";
import {
  Delete as DeleteIcon,
  Waves as RetiroIcon,
  Edit as EditIcon,
  Check as CheckIcon,
  Clear as ClearIcon,
} from "@material-ui/icons";
import {
  ordenaListaRetiros,
  estadoInicialListaRetiro,
  atualizaCampo,
} from "../retiroUtils";
import { useTranslations } from "adapters/i18n";

export const ListaRetiro = (props) => {
  const { t } = useTranslations();
  const { classes, listaRetiros, abreDialogExclusao, editaRetiro } = props;

  const listaRetirosOrdenadosPorId = ordenaListaRetiros(listaRetiros);
  const { valorCampoEditar, valorNovoNome, retiroSelecionadoEditar } =
    estadoInicialListaRetiro();

  const [campoEditar, trocaCampoEditar] = useState(valorCampoEditar);
  const [retiroEditado, trocaRetiroEditado] = useState(retiroSelecionadoEditar);
  const [novoNome, trocaNovoNome] = useState(valorNovoNome);

  const salvaNomeRetiro = (event) => {
    trocaNovoNome(event.target.value);
  };

  return (
    <List className={classes.listaRetiro} disablePadding>
      {listaRetirosOrdenadosPorId
        ? listaRetirosOrdenadosPorId.map((retiro, j) => {
            return [
              <ListItem key={`retiro-${j}`} id={`retiro-${j}`} disableGutters>
                <ListItemAvatar>
                  <Avatar className={classes.corAvatar}>
                    <RetiroIcon />
                  </Avatar>
                </ListItemAvatar>
                {atualizaCampo(campoEditar, retiroEditado.Nome, retiro.Nome) ? (
                  <div>
                    <TextField
                      placeholder={t("locales:new-name-placeholder")}
                      className={classes.campoEditar}
                      onChange={salvaNomeRetiro}
                      defaultValue={retiro.Nome}
                    />
                    <ListItemSecondaryAction
                      className={classes.listItemSecondary}
                    >
                      <IconButton aria-label={t("common:actions.edit")}>
                        <CheckIcon
                          className={classes.iconeEditar}
                          onClick={() => {
                            editaRetiro(retiro, novoNome);
                            trocaCampoEditar(false);
                            trocaRetiroEditado("");
                          }}
                        />
                      </IconButton>
                      <IconButton aria-label={t("common:actions.clear")}>
                        <ClearIcon
                          className={classes.iconeCancelarEdicao}
                          onClick={() => {
                            trocaCampoEditar(false);
                            trocaRetiroEditado("");
                          }}
                        />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </div>
                ) : (
                  <div>
                    <ListItemText
                      className={classes.textoRetiro}
                      primary={retiro.Nome}
                    />
                    <ListItemSecondaryAction
                      className={classes.listItemSecondary}
                    >
                      <IconButton aria-label={t("common:actions.edit")}>
                        <EditIcon
                          onClick={() => {
                            trocaCampoEditar(true);
                            trocaRetiroEditado(retiro);
                          }}
                        />
                      </IconButton>
                      <IconButton aria-label={t("common:actions.delete")}>
                        <DeleteIcon
                          onClick={() => abreDialogExclusao(retiro)}
                        />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </div>
                )}
              </ListItem>,
              <Divider
                key={`divisor-${j}`}
                id={`divisor-${j}`}
                className={classes.divisoria}
              />,
            ];
          })
        : null}
    </List>
  );
};

export default ListaRetiro;
